import { createAction } from "@reduxjs/toolkit";

import type { ApiInfo } from "legacy/constants/ApiConstants";

type UpdatePayload = { id: ApiInfo["id"]; data: Partial<ApiInfo> };

export const updatePartialApiInfo = createAction(
  "UPDATE_PARTIAL_API_INFO",
  (payload: UpdatePayload) => ({
    payload,
  }),
);
